import React from "react";
import { ArrowSvgAnime } from "./animation/ArrowSvgAnime";
import { PortUsbAnime } from "./animation/PortUsbAnime";
import { UsbFlashAnime } from "./animation/UsbFlashAnime";
import classes from "./EcpAnimationBlock.module.css";

const EcpAnimationBlock = () => {
  return (
    <>
      <div className={classes.mainWrapper}>
        <div className={classes.wrapperAnimationLogin}>
          <div className={classes.animationLoginText}>
            <p className={classes.animationLoginParagraph}>
              Не вынимайте устройство-носитель до завершения подписания
            </p>

            <p className={classes.animationLoginParagraph}>
              (это может занять <b>несколько минут</b>)
            </p>
          </div>

          <div className={classes.wrapperAnimationUsb}>
            <>
              <div className={classes.animationUsbPort}>
                <PortUsbAnime />
              </div>
              <div className={classes.wrapperAnimationUsbUsb}>
                <div className={classes.animationUsbUsb}>
                  <UsbFlashAnime />
                </div>
              </div>
            </>

            <div
              style={{ marginLeft: 20, marginTop: 10 }}
              className={classes.wrapperAnimationArrow}
            >
              <ArrowSvgAnime />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EcpAnimationBlock;
